module.exports = __webpack_public_path__ + "static/media/document-stack-outline.9f8be31c.svg";